import React from 'react';

import { Box } from '@bcp-nextgen-dx-component-factory/design-system';
import { rem } from '@helpers';

import { WizardMenuItem } from './block/wizardMenuItem';
import { useWizardMenuHelper } from './wizardMenu.helper';

export const WizardMenu: React.FC = () => {
	const { wizardMenuItems, selectedIndex, totalChildrenCount, totalParentWithChildrenCount } = useWizardMenuHelper();

	return (
		<Box styles={{ margin: rem(82, 0, 0, 0) }}>
			<Box styles={{ display: 'flex', flexDirection: 'column' }}>
				{wizardMenuItems.map((wizardMenuItem, parentIndex) => (
					<WizardMenuItem
						key={`wizard-menu-${parentIndex}`}
						item={wizardMenuItem}
						parentIndex={parentIndex}
						selectedIndex={selectedIndex}
						totalChildrenCount={totalChildrenCount(parentIndex)}
						totalParentWithChildrenCount={totalParentWithChildrenCount(parentIndex)}
					/>
				))}
			</Box>
		</Box>
	);
};
